module.exports = __webpack_public_path__ + "img/2.61fe6212.jpg";